export type GeoSimVpnMode = "clean" | "anonymous" | "hosting";

export type GeoSimSession = {
  country: string;
  state?: string | null;
  province?: string | null;
  city?: string | null;
  lang?: string | null;
  forceVariant?: string | null;
  simulateVpn: GeoSimVpnMode;
  simulateIp?: string | null;
  token: string;
  activatedAt: number;
};

export const GEO_SIM_STORAGE_KEY = "geo_sim_session_v1";

export const GEO_SIM_QUERY = {
  flag: "geo_sim",
  token: "gst",
  country: "country",
  state: "state",
  province: "province",
  city: "city",
  lang: "lang",
  forceVariant: "_force_variant",
  simulateVpn: "simulate_vpn",
  simulateIp: "simulate_ip",
} as const;
